import API from '@aws-amplify/api';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    createForms,
    createNewField,
    deleteForms,
    editForms,
    updateFormFieldResource,
    dataDownloadUploader
} from '@/graphql/mutations';
import { getFormList, getFormDetail, getFormFieldList } from '@/graphql/queries';
import { getExpressionFormMasterListByProject, prepareParamsGetItemFieldListByFieldId, prepareParamsGetListFormInCorporation, prepareParamsGetItemFieldListQACategoryOptions, prepareParamsGetSystemFormsOfCorp, prepareParamsGetFormField, prepareParamsGetSystemFieldOfCorp } from './dynamoDBRequestDto/DynamoDBFormRequestDto';
import { getPublicAPI } from './publicService';
import { getProjectById } from './projectService';

/**
 * Get form master list by project
 * @param {*} APIClient 
 * @param {*} corporationId 
 * @param {*} projectId 
 * @returns formList
 */
export const getFormMasterListByProject = async (APIClient, corporationId, projectId) => {
    try {
        let expression = getExpressionFormMasterListByProject(corporationId, projectId);

        let resFormList = await API.graphql({
            query: getFormList,
            variables: {
                params: {
                    expression: JSON.stringify(expression),
                    // corporationId
                }
            },
        });
        // check response query
        if (Utils.isEmptyObject(resFormList) || Utils.isEmptyArray(resFormList.data.getFormList)) {
            return [];
        }
        return resFormList.data.getFormList;
    } catch (error) {
        console.log('getFormMasterListByProject error: ', error);
        return [];
    }
};




/**
 * Get item field list by fieldId
 * @param {*} APIClient 
 * @param {*} usage 
 * @param {*} corporationId 
 * @param {*} fieldId 
 * @returns itemFieldList
 */
export const getItemFieldListByFieldId = async (APIClient, usage, corporationId, fieldId, nextToken = 'all') => {
    try {
        let params = prepareParamsGetItemFieldListByFieldId(usage, corporationId, fieldId, nextToken);
      
        let expression = JSON.stringify(params);
        let resItemFieldList = await API.graphql({
            query: getFormList,
            variables: {
                params: {
                    expression: expression,
                    // corporationId
                }
            },
        });
        // check response query
        if (Utils.isEmptyObject(resItemFieldList) || Utils.isEmptyArray(resItemFieldList.data.getFormList)) {
            return [];
        }

        return resItemFieldList.data.getFormList;
    } catch (err) {
        console.log('getItemFieldListByFieldId err: ', err);
        return [];
    }
};

/**
 * Get form list by corporation
 * @param {*} APIClient 
 * @param {*} corporationId 
 * @returns formList
 */
export const getFormListByCorporation = async (APIClient, corporationId, otherParams, listFormPreviewStep = []) => {
    try {
        let params = {
            corporationId,
            usage: Constant.FORM_USAGE.FORM
        };

        if(!Utils.isEmptyObject(otherParams)){
            params = {...params,...otherParams}
        }
        
        let resFormList = await API.graphql({
            query: getFormFieldList,
            variables: {
                params: {...params}
            },
        });

        // check response query
        if (Utils.isEmptyObject(resFormList) || Utils.isEmptyArray(resFormList.data.getFormFieldList)) {
            return [];
        }

        let listFormResult = resFormList.data.getFormFieldList;

        listFormPreviewStep = [...listFormPreviewStep, ...listFormResult]

        if(otherParams.size && listFormResult.length === otherParams.size && otherParams?.isGetForList){
            otherParams.from = listFormPreviewStep.length
            return await getFormListByCorporation(APIClient, corporationId, otherParams, listFormPreviewStep)
        }

        return listFormPreviewStep;
    } catch (err) {
        console.log('resFormList err :>>----------------------------- ', err);
        return [];
    }
};

export const getFormListGlobalStateAtom = async (APIClient, corporationId) => {
    try {
        let listForm = await getFormListByCorporation(APIClient, corporationId, {from :0, size: 300, isGetForList: true });
        let listFormClone = [];
        listForm.forEach(form => {
            let usingProjectsClone = [];
            let usingProjects = form?.usingProjects;
            if (!Utils.isEmptyArray(usingProjects)) {
                usingProjects.forEach(text => {
                    for (let i = 0; i < text.length; i++) {
                        let id;
                        if (text.charAt(i) === '_') {
                            if (i <= 7) {
                                id = text.substring(0, 44);
                            } else {
                                let startIndex = i - 7;
                                let end_index = i + 37;
                                id = text.substring(startIndex, end_index);
                            }
                            if (
                                id.length === 44 &&
                                Utils.getPrefixOfId(id) === 'project' &&
                                !usingProjectsClone.includes(id)
                            ) {
                                usingProjectsClone.push(id);
                            }
                        }
                    }
                });
            }
            let formClone = {...form};
            formClone.usingProjects = usingProjectsClone;
            listFormClone.push(formClone);
        });
        return listFormClone;
    } catch (err) {
        return [];
    }
};

/**
 * Get form list by project
 * @param {*} APIClient 
 * @param {*} corporationId 
 * @param {*} corporationId 
 * @returns formList
 */
export const getFormListByProject = async (APIClient, corporationId, projectId, authMode) => {
    try {
        let queryObject = {
            query: getFormFieldList,
            variables: {
                params: {
                    usage: Constant.FORM_USAGE.FORM,
                    corporationId,
                    projectId
                    // expression: expression,
                    // corporationId
                }
            }
        }

        if(authMode) {
            queryObject.authMode = authMode;
        }

        let resFormList = await API.graphql(queryObject);

        // check response query
        if (Utils.isEmptyObject(resFormList) || Utils.isEmptyArray(resFormList.data.getFormFieldList)) {
            return [];
        }
        return resFormList.data.getFormFieldList;
    } catch (err) {
        console.log('getFormListByProject', err);
        return [];
    }
};

function mergeArraysById(array1, array2) {
    // Tạo một Map từ array2 để tra cứu nhanh hơn
    const array2Map = new Map(array2.map(item => [item.id, item]));

    // Thay thế các item ở array1 bằng item tương ứng trong array2 có cùng id
    return array1.map(item1 => array2Map.get(item1.id) || item1);
};

const queryListItemOfField = async (field, defaultItemList = [], from = 0) => {
    defaultItemList = await getTagItemsByParentFieldId(field.id, 0, 300)
    field.defaultItemList = defaultItemList;
    delete field.isHasQueryItemList;
    delete field.totalItem

    return field
}

const bulkGetListFieldOfCorporation = async (
    APIClient,
    corporationId,
    otherParams,
    isGetDetailTagAndStatus = true,
    listPreviousStep = []
) => {
    try {
        let from = otherParams.from;
        let size = otherParams.size;

        let listPromise = [];

        for (let index = 0; index < 4; index++) {
            let otherParamsClone = { ...otherParams };
            otherParamsClone.from = from;
            listPromise.push(
                getPagingFieldListByCorporation(
                    APIClient,
                    corporationId,
                    otherParamsClone,
                    isGetDetailTagAndStatus
                )
            );
            from = from + size;
        }

        const listField = await Promise.all(listPromise);
        let isLastItem = false;
        listField?.forEach((listFieldResult, index) => {
            let dataListField = listFieldResult.data;
            if (dataListField.length < size && listFieldResult.status && index === 4) {
                isLastItem = true;
            }
            if (!listFieldResult.status) {
                isLastItem = true;
            }
            listPreviousStep = [...listPreviousStep, ...dataListField];
        });
        if (!isLastItem) {
            otherParams.from = from;
            return await bulkGetListFieldOfCorporation(
                APIClient,
                corporationId,
                otherParams,
                isGetDetailTagAndStatus,
                listPreviousStep
            );
        }
        return listPreviousStep;
    } catch (error) {
        console.log('listFieldPreviousStep :>>', error);
    }
};

export const getPagingFieldListByCorporation = async (
    APIClient,
    corporationId,
    otherParams,
    isGetDetailTagAndStatus = true
) => {
    try {
        let params = {
            corporationId,
            usage: Constant.FORM_USAGE.FIELD,
            isGetDetailTagAndStatus: isGetDetailTagAndStatus !== false
        };

        if (!Utils.isEmptyObject(otherParams)) {
            params = { ...params, ...otherParams };
        }
        let resFieldList = await API.graphql({
            query: getFormFieldList,
            variables: {
                params: params
            }
        });

        // check response query
        if (
            Utils.isEmptyObject(resFieldList) ||
            Utils.isEmptyArray(resFieldList.data.getFormFieldList)
        ) {
            return {
                status: false,
                data: []
            };
        };

        let listField = resFieldList.data.getFormFieldList
        let listTagFieldHasQueryItemList = listField?.filter(field => {
            return field.isHasQueryItemList
        });

        if (!Utils.isEmptyArray(listTagFieldHasQueryItemList)){
            let listPromise = listTagFieldHasQueryItemList.map(tagField => {
                return queryListItemOfField(tagField)
            });
            
            const listTagFiled =  await Promise.all(listPromise);
            listField = mergeArraysById(listField, listTagFiled)
        }

        return {
            status: true,
            data: listField
        };
    } catch (error) {
        console.log('listFieldPreviousStep :>> 4', error);
        return {
            status: false,
            data: []
        };
    }
};

const formatDataListFiledAfterQuery = (listField) => {
    listField = listField.map(field => {
        let itemList = [];
        let defaultItemList = [];
        field.structure = Utils.convertJSONDataToObject(field.structure);
        delete field.totalItem
        delete field.isHasQueryItemList
        switch (field.type) {
            case Constant.FORM_TYPE.FIELD_TAG:
                defaultItemList = field.defaultItemList;
                if (!Utils.isEmptyArray(defaultItemList)) {
                    defaultItemList = defaultItemList.map(item => {
                        let nameOfItem = Utils.convertJSONDataToObject(item.name);
                        if(typeof nameOfItem !== 'object'){
                            item.name = nameOfItem
                        }else{
                            item.name = Utils.getTextByLanguage(
                                Constant.LANGUAGE_TYPE.JP,
                                nameOfItem
                            );
                        }
                        itemList.push(generateItemFieldTag(item));

                        return item;
                    });
                }
                break;
            case Constant.FORM_TYPE.FIELD_WORKFLOW:
                defaultItemList = field.defaultItemList;
                if (!Utils.isEmptyArray(defaultItemList)) {
                    defaultItemList.forEach(item => {
                        itemList.push(generateItemFieldStatus(item));
                    });
                }
                break;
            default:
                itemList = [];
                defaultItemList = [];
                break;
        }
        field.itemList = Utils.isEmptyArray(itemList) ? [] : sortItemListFieldByNo(itemList);
        field.defaultItemList = Utils.isEmptyArray(defaultItemList) ? [] : defaultItemList;
        return field;
    });

    return listField
}

/**
 * Get field list by corporation
 * @param {*} APIClient 
 * @param {*} corporationId 
 * @returns formList
 */
export const getFieldListByCorporation = async (APIClient, corporationId, otherParams, listFieldPreviousStep = [], isGetDetailTagAndStatus = true) => {
    try {
        let params = {
            corporationId,
            usage: Constant.FORM_USAGE.FIELD,
            isGetDetailTagAndStatus: isGetDetailTagAndStatus !== false
        };

        if (otherParams.isGetForList) {
            listFieldPreviousStep = await bulkGetListFieldOfCorporation(APIClient, corporationId, otherParams, isGetDetailTagAndStatus, []);
            listFieldPreviousStep = formatDataListFiledAfterQuery(listFieldPreviousStep);
        } else {
            let resFieldList = await API.graphql({
                query: getFormFieldList,
                variables: {
                    params: params
                },
            });
            
            // check response query
            if (Utils.isEmptyObject(resFieldList) || Utils.isEmptyArray(resFieldList.data.getFormFieldList)) {
                return [];
            }
    
            let fieldList = resFieldList.data.getFormFieldList;
    
            let resultFieldList = [];
            fieldList.map(async field => {
                field.structure = Utils.convertJSONDataToObject(field.structure);
                if (field.type === Constant.FORM_TYPE.FIELD_WORKFLOW && field.itemList && !Utils.isEmptyArray(field.itemList)) {
                    let newItemList = [];
                    field.itemList.forEach(item => {
                        item.name = Utils.convertJSONDataToObject(item.name);
                        newItemList.push(item);
                    })
                    field.itemList = newItemList;
                }
                resultFieldList.push(field);
            });
            listFieldPreviousStep = [...resultFieldList];
        }

        return listFieldPreviousStep;
    } catch (err) {
        console.log(' getFieldListByCorporation err', err);
        return [];
    }
};

const sortItemListFieldByNo = (arr) => {
    try {
        if (Utils.isEmptyArray(arr)) {
            return [];
        }
        return arr.sort((a, b) => {
            return a.no - b.no
        });
    } catch (err) {
        console.log('sortItemListFieldByNo err: ', err)
        return arr;
    }
};

const generateItemFieldStatus = (item) => {
    let itemStructure = Utils.convertJSONDataToObject(item.structure);
    let itemField = {
        id: item.id,
        name: Utils.convertJSONDataToObject(item.name),
        viewForCustomer:
            typeof item.viewForCustomer === 'string'
                ? Utils.convertJSONDataToObject(item.viewForCustomer)
                : item.viewForCustomer,
        structure: item.structure,
        isShowInfo: false,
        isErrorValidate: false,
        errorMsg: {},
        no: itemStructure.no
    };

    return itemField;
};


const generateItemFieldTag = (item) => {
    let structure;
    try {
        structure = Utils.convertJSONDataToObject(item.structure);
    } catch (err) {
        console.log('generateItemFieldTag err: ', err)
        structure = item.structure;
    }
    
    if (typeof structure === 'undefined' || !structure) {
        structure = {
            isShowItemInTicket: true,
            no: 0
        };
    }


    let itemField = {
        id: item.id,
        name: `${item.name}`,
        isCheckbox: structure.isShowItemInTicket,
        isErrorValidate: false,
        isEditName: false,
        no: structure.no,
        hitNumber: Utils.isEmpty(item.hitNumber) ? 0 : item.hitNumber
    };

    return itemField;
};


export const updateFormField = async (APIClient, requestDto) => {
    try {
        let resData = await API.graphql({
            query: updateFormFieldResource,
            variables: {
                updateFormFieldResourceRequestDto: requestDto
            },
        });
        return resData.data?.updateFormFieldResource;
        
    } catch (error) {
        console.log('updateFormFieldResource', error)
    }
}

export const getFieldListOfFormInServer = async (
    corporationId,
    listId,
    authMode,
    tagField = Constant.FORM_USAGE.FIELD
) => {
    try {
        let resFieldList = [];
        const queryToFormTableWithBatchIdDto = {
            query: getFormList,
            variables: {
                params: {
                    ids: listId,
                    method: Constant.QUERY_METHOD.BATCH
                }
            }
        };
        resFieldList = await API.graphql(queryToFormTableWithBatchIdDto)
        let fieldInformList = resFieldList.data?.getFormList;
        return fieldInformList;
    } catch (error) {
        console.log('getFieldListOfFormInServer', error);
        return [];
    }
};

export const getFieldListInForm = async (APIClient, corporationId, listId, authMode) => {
    try {
        let fieldInformList = await getFieldListOfFormInServer(corporationId,listId, authMode);

        //get list field out org;
        let listIdFiledInOrg = [];
        fieldInformList?.forEach(field => {
            listIdFiledInOrg.push(field.id); 
        });

        let listIdOfFieldOutOrg = listId?.filter(id => {
            return !listIdFiledInOrg.includes(id)
        })

        let listFiledDetailOutOrg = [];

        if(!Utils.isEmptyArray(listIdOfFieldOutOrg)){
            let listQueryGetField = [];
            listIdOfFieldOutOrg.forEach(id=>{
                listQueryGetField.push(getFormById(API, id, authMode))
            });
            listFiledDetailOutOrg = await Promise.all(listQueryGetField)
        };

        return [...fieldInformList,...listFiledDetailOutOrg]
    } catch (err) {
        console.log('getFieldListByIdList', err);
        return [];
    }
};

/**
 * 
 * @param {*} APIClient 
 * @param {*} corporationId 
 * @param {*} parentFieldId 
 * @param {*} fieldData 
 * @param {*} nextToken is 'all' query all items, don't paginate
 * @returns 
 */
export const queryFieldChild = async (
    APIClient,
    corporationId,
    parentFieldId,
    fieldData,
    nextToken = 'all',
    defaultValue = null,
    isFromDetailTicket = false,
    projectInuseId = null
) => {
    try {
        let params = prepareParamsGetItemFieldListByFieldId(
            Constant.FORM_USAGE.TAG,
            corporationId,
            parentFieldId,
            nextToken
        );

        if (fieldData && fieldData.sysField === 'field_qa_category') {
            params = prepareParamsGetItemFieldListQACategoryOptions(corporationId);
            isFromDetailTicket = false;
        }
        // params.Limit = 20
        let paramsGetFieldChild = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_FIELD_CHILD_DATA,
            isFromDetailTicket: isFromDetailTicket,
            params: {
                corporationId,
                parentFieldId,
                nextToken,
                projectInuseId: projectInuseId,
            },
            expression: params
        };

        let resItemFieldList = await getPublicAPI(API, paramsGetFieldChild);
  
        let listFieldChildResult = Utils.convertJSONDataToObject(resItemFieldList?.payload);
        let fieldChildList = listFieldChildResult?.fieldListResponse;
        if (fieldData && fieldData.sysField === 'field_qa_category') {
            fieldChildList = fieldChildList?.filter(field => {
                return field?.sysField?.includes('field_qa_category_tag');
            });
        }

        

        //new response format for pagination. but still keep response format for functions used its but don't use pagination.
        if (listFieldChildResult?.hasOwnProperty('nextToken')) {

            //query selected tag items of tag field (default value), and it's first query in paginate query
            if (defaultValue) {
                const selectedTagItemIds = Utils.convertJSONDataToObject(defaultValue);
                // Check if any selected tag items are missing from the current fieldChildList
                let missingTagItemIds = [];
                if (!Utils.isEmptyArray(selectedTagItemIds)) {
                    const existingTagItemIds = fieldChildList.map(item => item.id) || [];
                    missingTagItemIds = selectedTagItemIds.filter(id => !existingTagItemIds.includes(id));
                }
                
                // only query selected tag items in first query paginate
                if (missingTagItemIds?.length > 0 && nextToken !== 'all' && nextToken === null) {
                    /**in first page paginate, we don't ensure selected tag fields existed is first paginate list,
                     * so we alway query selected tag list in first paginate query, filter items existed in first query paginate list
                     * and then re push selected tag items in above query to query paginate items response.
                     */
                    const selectedTagFields = await getFieldListOfFormInServer(
                        corporationId,
                        missingTagItemIds,
                        null,
                        Constant.FORM_USAGE.TAG
                    );


                    fieldChildList = [...fieldChildList, ...selectedTagFields];
                }
            }

            return {
                fieldChildList,
                nextToken: listFieldChildResult?.nextToken || null
            };
        }

        return fieldChildList;
    } catch (e) {
        console.log('queryFieldChild :>> errrrrrrr', e);
        return [];
    }
};


export const queryTagChildWithShortenedData = async (
    corporationId,
    parentFieldId,
    fieldData
) => {

    try {
        let resItemFieldList = {};
        if (fieldData && fieldData.sysField === Constant.SYS_FIELD.FIELD_QA_CATEGORY) {
            let params = prepareParamsGetItemFieldListQACategoryOptions(corporationId);
            let paramsGetFieldChildSystemQAField = {
                getApiType: Constant.GET_API_PUBLIC_TYPE.GET_FIELD_CHILD_DATA,
                expression: params
            };

            resItemFieldList = await getPublicAPI(API, paramsGetFieldChildSystemQAField);
        } else {
            let paramsGetFieldChild = {
                getApiType: Constant.GET_API_PUBLIC_TYPE.GET_TAG_CHILD_WITH_SHORTENED_DATA,
                parentFieldId: parentFieldId,
                debugId: new Date().getTime()
            };
            resItemFieldList = await getPublicAPI(API, paramsGetFieldChild); 
        }

        let listFieldChildResult = Utils.convertJSONDataToObject(resItemFieldList?.payload);
        let fieldChildList = listFieldChildResult?.fieldListResponse;

        if (fieldData && fieldData.sysField === Constant.SYS_FIELD.FIELD_QA_CATEGORY) {
            fieldChildList = fieldChildList?.filter(field => {
                return !!(field?.sysField?.includes(`${Constant.SYS_FIELD.FIELD_QA_CATEGORY}_tag`));
            });
        }

        return fieldChildList;
    } catch (e) {
        console.log('queryFieldChild :>> errrrrrrr', e);
        return [];
    }
};


/**
 * Create forms data
 * @param {*} APIClient 
 * @param {*} formData 
 * @returns formsData
 */
export const createFormsData = async (APIClient, formData) => {
    try {
        let input = {
            ...formData
        };
        let res = await API.graphql({
            query: createForms,
            variables: { input: input }
        });
        return res.data?.createForms;
    } catch (err) {
        console.log('createFormsData error: ', err);
        return null;
    }
};


/**
 * Update forms data
 * @param {*} APIClient 
 * @param {*} id 
 * @param {*} formData 
 * @returns formsData
 */
 export const updateFormsData = async (APIClient, id, formData) => {
    try {
        let input = {
            id: id,
            ...formData,
        };
        let res = await API.graphql({
            query: editForms,
            variables: { editFormRequestDto: input }
        });
        return res.data?.editForms;
    } catch (err) {
        console.log('updateFormData error: ', err);
        return null;
    }
};

export const deleteForm = async (APIClient, id) => {
    try {
        let input = {
            id: id
        };
        let res = await API.graphql({
            query: deleteForms,
            variables: { input: input }
        });
        return res.data?.deleteForms;
    } catch (err) {
        console.log('deleteForm error: ', err);
        return null;
    }
};

export const deleteTagItem = async (APIClient, id) => {
    try {
        let requestData = {
            formEditId: id,
            method: Constant.FORM_FIELD_MANAGEMENT_ACTION_FLAG.DELETE_TAG_ITEM
        };

        const result = await updateFormField(APIClient, requestData);
        return result;
    } catch (err) {
        console.log('delete tag item error: ', err);
        return null;
    }
};


/**
 * Create new field list
 * @param {*} APIClient 
 * @param {*} fieldList 
 * @returns 
 */
export const createNewFieldList = async (APIClient, fieldList, type = 'field') => {
    try {
        let resData = await API.graphql({
            query: createNewField,
            variables: {
                fieldList: fieldList,
                type: type
            },
        });
        return resData.data?.createNewField;
    } catch (err) {
        console.log('createNewField error: ', err);
        return null;
    }
};


export const bulkCreateTagItem = async (APIClient, itemList) => {
    try {
        let listPromise = []
        itemList.forEach(itemData => {
            listPromise.push(createFormsData(API, itemData))
        })
        const result = await Promise.all(listPromise).then(res => {
            return res
        }).catch((error) => {
            console.log('bulkCreateTagItem err :>> ', error);
        })
        const listId = Array.from(result, (item) => { return item.id });
        return listId
    } catch (err) {
        console.log('bulkCreateTagItem err :>> ', err);
    }
}

/**
 * getFormById
 * @param {*} APIClient 
 * @param {*} id 
 * @returns 
 */
export const getFormById = async (APIClient, id, authMode,isCheckUseInCategory,projectId) => {
    if (!id) {
        return {};
    };

    let params = {
        id: id
    };

    if(isCheckUseInCategory){
        params.isCheckUseInCategory = isCheckUseInCategory
    }

    if(projectId){
        params.currentProjectId = projectId
    }

    try {
        let queryObject = {
            query: getFormDetail,
            variables: {
                params: {
                    ...params
                }
            }
        }

        if(authMode) {
            queryObject.authMode = authMode;
        }

        let resFormDetail = await API.graphql(queryObject);
        return resFormDetail.data?.getFormDetail;
    } catch (err) {
        console.log('getForms error: ', err);
        return {};
    }
}



export const editForm = async (APIClient, requestDto) => {
    try {
        let resData = await API.graphql({
            query: editForms,
            variables: {
                editFormRequestDto: requestDto,
            },
        });
        return resData.data?.response;
    } catch (err) {
        console.log('editForm error: ', err);
        return null;
    }
}

/**
 * getFormListInCorporation
 * @param {*} APIClient 
 * @param {*} corporationId 
 * @returns 
 */
export const getFormListInCorporation = async (APIClient, corporationId) => {
    try {
        let expression = prepareParamsGetListFormInCorporation(Constant.FORM_USAGE.FORM, corporationId);

        let resFormList = await API.graphql({
            query: getFormList,
            variables: {
                params: {
                    expression: JSON.stringify(expression),
                    // corporationId
                }
            },
        });
        // check response query
        if (Utils.isEmptyObject(resFormList) || Utils.isEmptyArray(resFormList.data.getFormList)) {
            return [];
        }
        return resFormList.data.getFormList;
    } catch (error) {
        console.log('getFormListInCorporation error: ', error);
        return [];
    }
}


/**
 * getFormListCreatedByProject
 * @param {*} APIClient 
 * @param {*} corporationId 
 * @param {*} projectId 
 */
export const getFormListCreatedByProject = async (APIClient, corporationId, projectId) => {
    try {
        let allFormInCorp = await getFormListInCorporation(API, corporationId);
        if (Utils.isEmptyArray(allFormInCorp)) return [];

        let formListCreatedByProject = allFormInCorp.filter(form => form.affiliationProject === projectId);
        return formListCreatedByProject;
    } catch (error) {
        console.log('getFormListCreatedByProject error: ', error);
        return [];
    }
}


/**
 * getFormByIdWithoutAuthen
 * @param {*} APIClient 
 * @param {*} formId 
 * @returns 
 */
export const getFormByIdWithoutAuthen = async (APIClient, formId) => {
    if (!API || !formId) return;

    try {
        let response;

        let params = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_FORM_BY_ID,
            formId: formId
        }

        let getFormResult = await getPublicAPI(API, params);
        if (getFormResult.success) {
            response = Utils.convertJSONDataToObject(getFormResult.payload);
        }

        return response;
    } catch (err) {
        console.log('getFormByIdWithoutAuthen error: ', err);
        return {};
    }
}

export const getInfoFormFieldWithoutAuthen = async (APIClient, formId) => {
    try {
        let response;

        let params = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_INFO_FORM_FIELD,
            formId: formId
        }

        let getFormResult = await getPublicAPI(API, params);
        if (getFormResult.success) {
            response = Utils.convertJSONDataToObject(getFormResult.payload);
        }

        return response;
    } catch (err) {
        console.log('getFormByIdWithoutAuthen error: ', err);
        return {};
    }
}

export const getListFieldInFieldByFormId = async (formId) => {
    const formDetail = await getFormById(API,formId);
    let formStructure = Utils.convertJSONDataToObject(formDetail.structure);
    let fieldIdList = [];

    if(!Utils.isEmptyObject(formStructure)) {
        for (const fieldNumber in formStructure) {
            if (formStructure.hasOwnProperty(fieldNumber)) {
                if (formStructure[fieldNumber].hasOwnProperty('field')) {
                    fieldIdList.push(formStructure[fieldNumber]['field']);
                }
            }
        }
    }
    const listFieldDetail = await getFieldListInForm(API,formDetail.affiliationOrganization,fieldIdList);

    return listFieldDetail

}


/**
 * getEmailFormOfProject
 * @param {*} corporationId 
 * @param {*} projectId 
 * @param {*} formAtom 
 * @returns 
 */
export const getEmailFormOfProject = async (corporationId, projectId, formAtom) => {
    if (!corporationId || !projectId) return {};

    // Get from Atom
    if (!Utils.isEmptyArray(formAtom)) {
        let emailFormOfProject = formAtom.find(
            form =>
                form.type === Constant.FORM_TYPE.EMAIL_FORMAT &&
                form.affiliationProject === projectId
        );
        if (!Utils.isEmptyObject(emailFormOfProject)) {
            return emailFormOfProject;
        }
    }

    try {
        let expression = prepareParamsGetSystemFormsOfCorp(corporationId);

        let resFormList = await API.graphql({
            query: getFormList,
            variables: {
                params: {
                    expression: JSON.stringify(expression)
                }
            },
        });

        let allSystemForm = resFormList.data.getFormList;
        if (Utils.isEmptyArray(allSystemForm)) return {};

        let emailForm = allSystemForm.find(form => form.type === Constant.FORM_TYPE.EMAIL_FORMAT && form.affiliationProject === projectId);
        return emailForm || {};
    } catch (error) {
        console.log('getEmailFormOfProject error: ', error);
        return {};
    }
}

export const getFormFieldWithCondition = async (corporationId, projectId, usage, type, definition) => {
    if (!corporationId || !projectId) return [];

    try {
        const expression = prepareParamsGetFormField(corporationId, projectId, usage, type, definition);
        const resFormList = await API.graphql({
            query: getFormList,
            variables: {
                params: {
                    expression: JSON.stringify(expression)
                    // corporationId
                }
            }
        });
        const allFormFieldsCanBeFound = resFormList?.data?.getFormList;

        if (Utils.isEmptyArray(allFormFieldsCanBeFound)) return [];

        return allFormFieldsCanBeFound || []
    } catch (error) {
        console.log('getEmailFormOfProject error: ', error);
        return [];
    }
}

export const getTagItemsByParentFieldId = async (id, from, size) => { 
    try {
        let resItemFieldList = await API.graphql({
            query: getFormList,
            variables: {
                params: {
                    ids: id,
                    method: Constant.QUERY_METHOD.GET_TAG_ITEMS_BY_FIELD_ID,
                    from: from,
                    size: size
                }
            }
        });
        // check response query
        if (
            Utils.isEmptyObject(resItemFieldList) ||
            Utils.isEmptyArray(resItemFieldList.data.getFormList)
        ) {
            return [];
        }

        return resItemFieldList.data.getFormList;
    } catch (err) {
        console.log('getTagItemsByParentFieldId err: ', err);
        return [];
    }
};

export const getTagItemsByParentFieldIds = async (parentFieldIds = []) => {
    try {
        let resItemFieldList = await API.graphql({
            query: getFormList,
            variables: {
                params: {
                    ids: parentFieldIds,
                    method: Constant.QUERY_METHOD.GET_TAG_ITEMS_BY_TAG_FIELD_IDS
                }
            }
        });
        // check response query
        if (
            Utils.isEmptyObject(resItemFieldList) ||
            Utils.isEmptyArray(resItemFieldList.data.getFormList)
        ) {
            return [];
        }

        return resItemFieldList.data.getFormList;
    } catch (err) {
        console.log('getTagItemsByParentFieldIds err: ', err);
        return [];
    }
};

export const searchTagItemsByFieldIdAndKeyword = async (fieldId, keywords) => {
    try {
        let resItemFieldList = await API.graphql({
            query: getFormList,
            variables: {
                params: {
                    fieldId: fieldId,
                    keywords: keywords,
                    method: Constant.QUERY_METHOD.SEARCH_TAG_ITEMS_BY_FIELD_ID_AND_KEYWORD
                }
            }
        });
        // check response query
        if (
            Utils.isEmptyObject(resItemFieldList) ||
            Utils.isEmptyArray(resItemFieldList.data.getFormList)
        ) {
            return [];
        }

        return resItemFieldList.data.getFormList;
    } catch (err) {
        console.log('searchTagItemsByFieldIdAndKeyword err: ', err);
        return [];
    }
};

export const downloadTagItemsByTagFieldId = async ({
    corporationInuseId,
    projectInuseId,
    userInuseId,
    tagFieldId
}) => {
    try {
        const response = await API.graphql({
            query: dataDownloadUploader,
            variables: {
                dataDownloadUploaderRequestDto: {
                    action: Constant.DOWNLOAD_UPLOAD_METHOD.DOWNLOAD,
                    userRequestDto: {
                        corporationInuseId,
                        projectInuseId,
                        userInuseId
                    },
                    downloadRequestDto: {
                        targetDownloadId: tagFieldId
                    }
                }
            }
        });
 
        return response?.data || {}
    } catch (err) {
        console.log('downloadTagItemsByTagFieldId: ', err);
        return null;
    }
};

export const uploadTagItemsByTagFieldId = async ({
    corporationInuseId,
    projectInuseId,
    userInuseId,
    targetUploadId,
    uploadFileUrl,
    taskId
}) => {

    try {
        const response = await API.graphql({
            query: dataDownloadUploader,
            variables: {
                dataDownloadUploaderRequestDto: {
                    action: Constant.DOWNLOAD_UPLOAD_METHOD.UPLOAD,
                    userRequestDto: {
                        corporationInuseId,
                        projectInuseId,
                        userInuseId
                    },
                    uploadRequestDto: {
                        targetUploadId,
                        uploadFileUrl,
                        taskId
                    }
                }
            }
        });
        
        return response?.data || {}
    } catch (err) {
        console.log('downloadTagItemsByTagFieldId: ', err);
        return null;
    }
};

export const getSystemFieldOfCorp = async (corporationId) => {

    try {
        let expression = prepareParamsGetSystemFieldOfCorp(corporationId);

        let resFormList = await API.graphql({
            query: getFormList,
            variables: {
                params: {
                    expression: JSON.stringify(expression)
                }
            },
        });

        let allSystemField = resFormList.data.getFormList;
        if (Utils.isEmptyArray(allSystemField)) return [];

        return allSystemField
      
    } catch (error) {
        console.log('getEmailFormOfProject error: ', error);
        return {};
    }
}


/**
 * isFormShareForProject
 * @param {*} formDetail 
 * @param {*} selectedProjectId 
 * @param {*} selectedProjectData 
 * @returns 
 */
export const isFormShareForProject = async (formDetail, selectedProjectId, selectedProjectData) => {
    if (Utils.isEmptyObject(formDetail) || !selectedProjectId) return false;

    let shareStatus = false;
    if (formDetail.affiliationProject === selectedProjectId) return true;
    let projectInUse = selectedProjectData;
    if (!projectInUse || Utils.isEmptyObject(projectInUse)) {
        projectInUse = await getProjectById(API, selectedProjectId);
    }

    if (
        !projectInUse ||
        formDetail.affiliationOrganization === projectInUse.affiliationOrganization
    ) {
        return true;
    }

    switch (formDetail.shareOption) {
        case Constant.SHARE_OPTION.INTERNAL_ORG:
            shareStatus = false;
            break;
        case Constant.SHARE_OPTION.ALL_ORG:
            shareStatus = true;
            break;
        case Constant.SHARE_OPTION.SPECIFIC_ORG:
        case Constant.SHARE_OPTION.B2B_CUSTOMER_ORG:
        case Constant.SHARE_OPTION.B2B_HELPDESK_ORG:
            shareStatus = formDetail.shareRange.includes(projectInUse.affiliationOrganization);
            break;

        default:
            break;
    }

    return shareStatus;
}

export const getFormFieldByIsNotAuthentication = async (ids = []) => {
    try {
        const response = await getPublicAPI(null, {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_FORM_BY_IDS,
            ids: ids
        });
        return Utils.convertJSONDataToObject(response?.payload);
    } catch (err) {
        console.log('getFormFieldByIsNotAuthentication err: ', err);
        return [];
    }
};

export const getTicketTelephoneStatusDetail = async (ticketDetail, userId, isHelpdeskSide = true) => {
    try {
        // Validate ticketDetail params required:
        if (
            !ticketDetail?.telephoneStatus ||
            !ticketDetail?.affiliationOrganization ||
            !ticketDetail?.metaData ||
            !ticketDetail?.customer ||
            !userId
        ) return {};

        const response = await getPublicAPI(null, {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_TELEPHONE_STATUS_DETAIL,
            ticketDetail,
            userId,
            isHelpdeskSide
        });
        return Utils.convertJSONDataToObject(response?.payload);
    } catch (error) {
        console.log('getTicketTelephoneStatusDetail error >>>', error);
        return {};
    }
}